import api from './api';
import { todayString } from './appDateTime';
import { downloadBlob, getApiErrorMessage, parseBlobError } from './blobDownload';

export async function fetchFeedbackAttachmentBlob(attachmentId, view = false) {
  const endpoint = view
    ? `/feedback/attachments/${attachmentId}/view`
    : `/feedback/attachments/${attachmentId}/download`;
  const res = await api.get(endpoint, { responseType: 'blob' });
  const msg = await parseBlobError(res.data);
  if (msg) {
    throw new Error(msg);
  }
  if (!(res.data instanceof Blob) || res.data.size === 0) {
    throw new Error('Attachment file is empty or unavailable');
  }
  return res.data;
}

export async function downloadFeedbackAttachment(attachmentId, filename) {
  const blob = await fetchFeedbackAttachmentBlob(attachmentId, false);
  await downloadBlob(blob, filename || 'attachment');
}

export async function viewFeedbackAttachment(attachmentId) {
  return fetchFeedbackAttachmentBlob(attachmentId, true);
}

export async function exportFeedbackXlsx(params) {
  const query = params instanceof URLSearchParams ? params.toString() : String(params || '');
  const res = await api.get(`/feedback/export?${query}`, { responseType: 'blob' });
  const date = todayString();
  await downloadBlob(res.data, `feedback-export-${date}.xlsx`);
}

export { getApiErrorMessage };
